import { useCallback, useState } from 'react';

export const useCarousel = (size: number) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const lastIndex = size - 1;

  const goForward = useCallback(() => {
    setCurrentIndex((prevCurrentIndex) => {
      const newCurrentIndex = prevCurrentIndex + 1;

      if (newCurrentIndex > lastIndex) {
        return 0;
      }

      return newCurrentIndex;
    });
  }, [lastIndex]);

  const goBack = useCallback(() => {
    setCurrentIndex((prevCurrentIndex) => {
      const newCurrentIndex = prevCurrentIndex - 1;

      if (newCurrentIndex < 0) {
        return lastIndex;
      }

      return newCurrentIndex;
    });
  }, [lastIndex]);

  return {
    currentIndex,
    setCurrentIndex,
    goForward,
    goBack,
  };
};
